module.exports = __webpack_public_path__ + "static/images/51211ecb8886bb7c234e86fd09d02fd9.webp";